<template>
  <div class="container-370 text-center">
    <div class="main-title mb-20 mt-40"><p>予約の目的を入力してください（任意）</p></div>

    <input class="input h-44 w-370 p-15" placeholder="新型コロナや糖尿病など" v-model="localTitle"/>
    <div class="mt-20"><p>※入力内容は一覧や通知（メールなど）で表示されます。</p></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    }
  },
  computed: {
    localTitle: {
      get () { return this.value },
      set (localTitle) { this.$emit('input', localTitle ? localTitle : '') }
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/meetings/create/SetTitle.vue